module.exports = __webpack_public_path__ + "static/media/writing_n_translations_landingpage.e469e5bd.webp";